// Business survey
export const WORK_FREQUENCY_QUESTION_ID = "6";
export const WORK_FREQUENCY_FULL_TIME_ANSWER_ID = "460";
export const WORK_FREQUENCY_PART_TIME_ANSWER_ID = "461";
export const WORK_FREQUENCY_OCCASIONALLY_ANSWER_ID = "462";

export const BUY_FREQUENCY_QUESTION_ID = "7";
export const BUY_FREQUENCY_WEEKLY_ANSWER_ID = "463";
export const BUY_FREQUENCY_MONTHLY_ANSWER_ID = "464";
export const BUY_FREQUENCY_SEMI_ANNUALLY_ANSWER_ID = "465";

export const LICENSE_QUESTION_ID = "8";
export const LICENSE_YES_ANSWER_ID = "466";
export const LICENSE_NO_ANSWER_ID = "467";
export const LICENSE_IN_PROCESS_ANSWER_ID = "468";

export const PERMIT_QUESTION_ID = "9";
export const PERMIT_YES_ANSWER_ID = "469";
export const PERMIT_NO_ANSWER_ID = "470";
export const PERMIT_NOT_SURE_ANSWER_ID = "471";

// Member survey
export const MEMBER_QUESTION_ID = "12";
export const MEMBER_SEARCH_ENGINE_ANSWER_ID = "479";
export const MEMBER_SOCIAL_MEDIA_ANSWER_ID = "480";
export const MEMBER_WORD_OF_MOUTH_ANSWER_ID = "481";
export const MEMBER_OTHER_ANSWER_ID = "482";

// School survey
export const SCHOOL_USER_QUESTION_ID = "10";
export const SCHOOL_USER_INSTRUCTOR_ANSWER_ID = "472";
export const SCHOOL_USER_ADMINISTRATOR_ANSWER_ID = "473";
export const SCHOOL_USER_STUDENT_FOR_SCHOOL_ANSWER_ID = "474";
export const SCHOOL_USER_STUDENT_FOR_SELF_ANSWER_ID = "475";

export const PAYMENT_QUESTION_ID = "11";
export const PAYMENT_PURCHASE_ORDER_ANSWER_ID = "476";
export const PAYMENT_CREDIT_CARD_ANSWER_ID = "477";
export const PAYMENT_NOT_SURE_ANSWER_ID = "478";

// Charity survey
export const CHARITY_QUESTION_ID = "13";
export const CHARITY_NON_PROFIT_ANSWER_ID = "483";
export const CHARITY_CHARITY_ANSWER_ID = "484";
export const CHARITY_DONATION_ANSWER_ID = "485";
